<div class="ts-review-modal__trigger" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggle()">
  <ng-content></ng-content>
</div>

<ng-template
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="onCancel()"
  cdkConnectedOverlay
>
  <div class="ts-review-modal__panel">
    <ts-dialog [title]="title()" [showFooter]="true" (closeDialog)="onCancel()">
      <div ts-dialog-body class="ts-review-modal__body">
        <div class="ts-review-modal__editor">
          <quill-editor
            class="w-full"
            [(ngModel)]="commentModel"
            [modules]="quillModules"
            [placeholder]="placeholder()"
          />
        </div>

        <div class="ts-review-modal__segmented" role="group">
          <button
            type="button"
            class="ts-review-modal__segment ts-review-modal__segment--approve"
            [ngClass]="{ 'ts-review-modal__segment--selected': selectedType() === 'approve' }"
            (click)="select('approve')"
          >
            <ts-icon icon="check_circle" />
            <span>Approve</span>
          </button>
          <button
            type="button"
            class="ts-review-modal__segment ts-review-modal__segment--reject"
            [ngClass]="{ 'ts-review-modal__segment--selected': selectedType() === 'request_changes' }"
            (click)="select('request_changes')"
          >
            <ts-icon icon="cancel" />
            <span>Request changes</span>
          </button>
        </div>

        @if (activeCalloutText(); as calloutText) {
          <ts-callout-box [type]="activeCalloutType()">{{ calloutText }}</ts-callout-box>
        }
      </div>

      <div ts-dialog-actions class="flex flex-row items-center gap-2">
        <ts-button variant="secondary" (buttonClick)="onCancel()">Cancel</ts-button>
        <ts-button [type]="'flat'" [color]="submitColor()" [disabled]="!canSubmit()" (buttonClick)="onSubmit()">
          Submit review
        </ts-button>
      </div>
    </ts-dialog>
  </div>
</ng-template>
